var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        persistent: "",
        "max-width": "1000px",
        "content-class": "report-error-dialog",
        fullscreen: _vm.$vuetify.breakpoint.smAndDown,
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm.dialog
        ? [
            _c(
              "v-flex",
              { staticStyle: { overflow: "auto" } },
              [
                _c(
                  "v-card",
                  {
                    staticStyle: { position: "relative" },
                    attrs: { tile: "", flat: "" },
                  },
                  [
                    _vm.processInstanceId
                      ? _c(
                          "v-chip",
                          {
                            staticClass: "caption mt-1 mr-1",
                            staticStyle: {
                              position: "absolute",
                              right: "4px",
                              top: "4px",
                            },
                            attrs: { small: "" },
                          },
                          [_vm._v(_vm._s(_vm.processInstanceId))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-card-text", [
                      !_vm.loading
                        ? _c("div", { staticClass: "mb-4 mt-2" }, [
                            _c(
                              "div",
                              { staticClass: "headline mb-3 break-all" },
                              [
                                _vm._t(
                                  "title",
                                  function () {
                                    return [
                                      _vm.isError
                                        ? _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-1",
                                              attrs: {
                                                color: "error",
                                                large: "",
                                              },
                                            },
                                            [_vm._v("error")]
                                          )
                                        : _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-1",
                                              attrs: {
                                                large: "",
                                                color: "success",
                                              },
                                            },
                                            [_vm._v("check_circle")]
                                          ),
                                      _vm._v(" "),
                                      _vm.displayMessage
                                        ? _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.displayMessage
                                              ),
                                            },
                                          })
                                        : _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                `${_vm.title} ${
                                                  _vm.isError
                                                    ? "failed"
                                                    : "successful"
                                                }`
                                              ),
                                            },
                                          }),
                                    ]
                                  },
                                  { isError: _vm.isError },
                                  _vm.executionResults
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.hasLogs
                              ? _c("div", [
                                  _vm._v(" See the logs below for details. "),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.unexpectedErrorMessage
                              ? _c("div", [
                                  _vm._v(
                                    "\n              An unexpected error occurred.\n            "
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              [
                _vm.hasLogs
                  ? _c(
                      "v-card",
                      {
                        staticStyle: {
                          "max-height": "450px",
                          overflow: "auto",
                        },
                        attrs: { flat: "", tile: "" },
                      },
                      [
                        _c(
                          "v-card-title",
                          { staticClass: "title py-2" },
                          [
                            _c("v-icon", { staticClass: "mr-1" }, [
                              _vm._v("receipt_long"),
                            ]),
                            _vm._v(
                              "\n          Logs (" +
                                _vm._s(_vm.userLogs.length) +
                                ")\n          "
                            ),
                            _c(
                              "SecondaryBtn",
                              {
                                attrs: {
                                  flat: "",
                                  small: "",
                                  color: "info",
                                  icon: _vm.showLogs
                                    ? "expand_less"
                                    : "expand_more",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.showLogs = !_vm.showLogs
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.showLogs ? "Hide logs" : "Show logs"
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.showLogs
                          ? _c(
                              "v-card-text",
                              [
                                _c("UserLogs", {
                                  staticClass: "pb-1 card-bg-3",
                                  attrs: { userLogs: _vm.userLogs },
                                }),
                                _vm._v(" "),
                                _c("v-divider"),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  {
                    staticClass: "pt-3",
                    staticStyle: { "max-height": "450px", overflow: "auto" },
                    attrs: { flat: "", tile: "" },
                  },
                  [
                    _c(
                      "v-card-title",
                      { staticClass: "title py-2" },
                      [
                        _c("v-icon", { staticClass: "mr-1" }, [
                          _vm._v("support"),
                        ]),
                        _vm._v("\n          Recommended actions\n        "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-card-text",
                      { staticClass: "pt-0" },
                      [
                        _vm.isError
                          ? _vm._t(
                              "actions",
                              function () {
                                return [
                                  _vm._v(
                                    "\n            There are no recommended actions. Please try again or contact Hatfield support for assistance.\n          "
                                  ),
                                ]
                              },
                              { isError: _vm.isError },
                              _vm.executionResults
                            )
                          : _vm._t(
                              "next",
                              function () {
                                return [
                                  _vm._v(
                                    "\n            There are no recommended actions.\n          "
                                  ),
                                ]
                              },
                              { isError: _vm.isError },
                              _vm.executionResults
                            ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  [
                    _c("v-divider"),
                    _vm._v(" "),
                    _c(
                      "v-card-actions",
                      [
                        _vm.isError
                          ? _c("ContactSupport", {
                              attrs: {
                                userLogs: _vm.userLogs,
                                displayMessage: _vm.displayMessage,
                                processInstanceId: _vm.processInstanceId,
                                message: _vm.unexpectedErrorMessage,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "SecondaryBtn",
                          {
                            attrs: { icon: "close" },
                            on: {
                              click: function ($event) {
                                return _vm.attemptToClose()
                              },
                            },
                          },
                          [_vm._v("\n            Close\n          ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }